import {ENVIRONMENT_OVERRIDE} from './../../plugins/feature/feature-list'
import geoService from '../../services/geo-ip-service'
import {USER_REGION, USER_COUNTRY_CODE} from '../../enums/local-storage-keys'
import {DEFAULT} from '../../enums/regions'

const AVAILABLE_ENVIRONMENTS = ['dev', 'uat', 'preprod', 'prod']
// Regions
let REGION = DEFAULT

let VERSION = require('../../version.json').version
// Environments
export const DEV = 'dev'
export const UAT = 'uat'
export const PREPROD = 'preprod'
export const PROD = 'prod'

let ENV = PROD

export const LOCALHOST = /(localhost|\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3})/
export const SMEX_URL = 'exchange.smarttech.com'
export const SMEX_PROD_URL = 'exchange.smarttech-prod.com'

const REGION_MAPPINGS = Object.freeze({
  [DEV]: require('../../region-mapping/dev/regions.json'),
  [UAT]: require('../../region-mapping/uat/regions.json'),
  [PREPROD]: require('../../region-mapping/preprod/regions.json'),
  [PROD]: require('../../region-mapping/regions.json')
})

const Environment = {
  availableEnvironments() {
    return AVAILABLE_ENVIRONMENTS
  },
  isValidEnvironment(env) {
    return this.availableEnvironments().indexOf(env) > -1
  },
  getHostname() {
    if (window && window.location && window.location.hostname) {
      return window.location.hostname
    }
    return ''
  },
  determineEnvironment(host) {
    ENV = this.getDefaultEnvironment(host)

    /* env=someEnvironment overrides environmental behavior set in the debug panel */
    if (ENV !== PROD && window.sessionStorage) {
      let urlOverride = new RegExp('env=([^&]*)', 'i').exec(window.location.search)
      let environmentOverride = window.sessionStorage.getItem(ENVIRONMENT_OVERRIDE.name + '-value')

      if (urlOverride && this.isValidEnvironment(urlOverride[1])) {
        console.log(`Environment URL override is set to ${urlOverride[1]}. Default for this domain is ${ENV}.`)
        ENV = urlOverride[1]
        window.sessionStorage.setItem(ENVIRONMENT_OVERRIDE.name, !!urlOverride[1])
        window.sessionStorage.setItem(ENVIRONMENT_OVERRIDE.name + '-value', ENV)
      } else if (environmentOverride && this.isValidEnvironment(environmentOverride)) {
        console.log(`Environment override is set to ${environmentOverride}. Default for this domain is ${ENV}.`)
        ENV = environmentOverride
      }
    } else {
      ENV = this.getDefaultEnvironment(host)
    }
  },
  getDefaultEnvironment(host) {
    let hostname = host || this.getHostname()
    if (hostname) {
      let hostnameMatchUat = hostname.match(/smart-contentportal-uat.appspot.com|smarttech-uat/)
      if (hostnameMatchUat) {
        return UAT
      }

      let hostnameMatchPreprod = hostname.match(/smart-contentportal-preprod.appspot.com|smarttech-preprod/)
      if (hostnameMatchPreprod) {
        return PREPROD
      }

      let hostnameMatchDev = hostname.match(/localhost|smart-contentportal-dev.appspot.com|smarttech-dev/)
      if (hostnameMatchDev) {
        return DEV
      }
    }
    return PROD
  },
  getEnv() {
    return ENV
  },
  getRegion() {
    return REGION
  },
  isDev() {
    return ENV === 'dev'
  },
  isUat() {
    return ENV === 'uat'
  },
  isPreprod() {
    return ENV === 'preprod'
  },
  isProd() {
    return ENV === 'prod'
  },
  serviceUrlFor(serviceName, region) {
    let serviceRegion = region || REGION
    return this.serviceRegionUrl(serviceRegion, serviceName)
  },
  getVersion() {
    return !VERSION ? '0.0.0.0' : VERSION
  },
  getCountryCodeServiceRegion(countryCode) {
    const countryMapping = REGION_MAPPINGS[ENV].countries
    if (countryMapping[countryCode]) {
      return countryMapping[countryCode].region
    } else {
      return DEFAULT
    }
  },
  serviceRegionUrl(region, service) {
    return REGION_MAPPINGS[ENV].regions[region].mapping[service]
  },
  determineServiceRegion() {
    return new Promise(resolve => {
      const urlParams = new URLSearchParams(window.location.search).get('region')
      if (urlParams) {
        this.setRegion(urlParams.toLowerCase())
        resolve()
      } else {
        const IDConfirmedRegion = new URL(location.href).searchParams.get('new_region')
        const cachedRegion = window.localStorage.getItem(USER_REGION)
        if (IDConfirmedRegion) {
          this.setRegion(IDConfirmedRegion)
          resolve()
        } else if (!cachedRegion) {
          return geoService.resolveLocation().then(locationData => {
            const currentRegion = this.getCountryCodeServiceRegion(locationData.body.countryCode)
            this.setCountryCode(locationData.body.countryCode)
            this.setRegion(currentRegion)
            resolve()
          })
        } else {
          REGION = cachedRegion
          resolve()
        }
      }
    })
  },
  setRegion(region) {
    REGION = region
    window.localStorage.setItem(USER_REGION, REGION)
  },
  setCountryCode(countryCode) {
    window.localStorage.setItem(USER_COUNTRY_CODE, countryCode)
  }
}
Environment.determineEnvironment()

export default Environment
